<template>
  <portlet
      :icon="'fal fa-folder-open'"
      :title="'Plaatsingen'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <a
          :href="$CLOUD_API+'/export/placements?from=candidateId&id=' + candidateId + '&access_token=' + this.$store.state.oAuthToken">
        <button class="btn btn-primary">
          <i class="fas fa-file-excel mr-2"></i> Exporteren naar Excel
        </button>
      </a>
    </template>
    <template slot="portletBody">
      <div class="table-responsive vacancy-info">

        <table class="table dataTable table-bordered table-striped"
               v-if="getCandidatePlacements(candidateId).length !== 0">
          <thead>
          <tr>
            <th>Bedrijf</th>
            <th>Plaats</th>
            <th>Vacature</th>
            <th>Salaris (p/u)</th>
            <th>Begin datum</th>
            <th>Einddatum</th>
            <th>Pensioen</th>
            <th>Geplaatst door</th>

            <th>Opties</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(placement, index) in getCandidatePlacements(candidateId)" :key="placement.index">

            <td v-if="getCustomer(placement.customerId)">

              <router-link :to="'/customers/'+ placement.customerId">
                {{ getCustomerName(placement.customerId) }}
              </router-link>
            </td>
    <td v-else>{{placement.customerId}}</td>
            <td>{{ getCustomerLocation(placement.customerId) }}</td>
            <td>{{ getVacancyName(placement.vacancyId) }}</td>
            <td>€ {{ placement.hourlyWage }}</td>
            <td>{{ placement.startDate|day }}</td>

            <td>
              <template v-if="placement.endDate">{{ placement.endDate|day }}</template>
              <template v-else></template>
            </td>
            <td>{{ placement.retirement }}</td>

            <td>
             <p v-if="placement.placedBy">
              <span :key="index" v-for="(placed,index) in placement.placedBy"> {{ placed.displayName }}<br></span>
             </p>
            <p v-else>-</p>
            </td>
            <td class="td-actions actions-column">
              <template v-if="isAdmin">
                <edit-candidate-end-date
                    :index="index"
                    :title="'Plaatsing aanpassen'"
                    :placement="placement"
                    :name="'placement'"
                    @saveChanges="editPlacement($event)"
                ></edit-candidate-end-date>
                <a href="javascript:;" class="action-icon" @click="syncWithHourApp(placement)">
                  <i class="far fa-mobile" title="Sync met hour app"></i>
                </a>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </portlet>
</template>


<script>
import {mapGetters} from "vuex";
import Vue from 'vue';
import store from '@/store';
import editCandidateEndDate from "../../editCandidatePlacing";
import { Can } from '../../../../permission/ability.js';
import { RIGHTS } from '../../../views/roles/rights.js';
import { buildEmploymentUpdatePayload, syncPlacementToHourApp } from "@/utils/placementSync";

export default {
  props: ["candidateId"],
  components: {editCandidateEndDate},
  data() {
    return {};
  },
  methods: {
    async syncWithHourApp(placement) {
        const outcome = await syncPlacementToHourApp(this.$store.dispatch, {
          ApiClient: Vue.prototype.$ApiClient,
          placement,
          candidate: this.getCandidate(placement.candidateId),
          customer: this.getCustomer(placement.customerId),
        });

        if (!outcome.ok) {
          this.$toasted.global.failedRequest({message: outcome.message});

          return;
        }

        this.$toasted.global.successRequest({
          message: "Plaatsing gesynced met hour app"
        });
    },
    editPlacement(placement) {
      if (placement.id) {
        let id = placement.id;

        if (placement.endDate) {
          placement.endDate = moment(placement.endDate).format("YYYY-MM-DD");

          var candidate = this.getCandidate(this.candidateId);
          if (candidate && candidate.fase34) {
            this.$swal({
              title: 'Let op!',
              text: 'Let op, deze kandidaat zit in fase 3/4 graag actie ondernemen.',
              type: 'warning',
              confirmButtonText: 'OK'
            });
          }
        }

        $(".modal").modal("hide");
        $(".modal-backdrop").remove();

        let p = this.getPlacement(id)
        this.$store.dispatch("placements/set", {
          id,
          endDate: placement.endDate,
          hourlyWage: placement.hourlyWage,
          retirement: placement.retirement ? placement.retirement : null,
        }).then(async () => {
          this.$toasted.global.successRequest({
            message: "Plaatsing aangepast"
          });
          // Update flexworker in hour app
          this.$store.dispatch('employments/update', {ApiClient: Vue.prototype.$ApiClient, employment: buildEmploymentUpdatePayload({placement: p, endDate: placement.endDate})}).catch(() => {
            this.$toasted.global.failedRequest({
              message: "Plaatsing aangepast, maar synchronisatie met hour app is mislukt"
            });
          });

          if (placement.endDate) {
            await this.closeSickDaysAndNotify(placement.endDate);
          }
        }).catch(() => {
          this.$toasted.global.failedRequest();
        });
      }
    },
    async closeSickDaysAndNotify(endDate) {
      try {
        const snapshot = await this.$FB
          .collection('candidates')
          .doc(this.candidateId)
          .collection('sickDays')
          .where('endDate', '==', null)
          .get();

        if (snapshot.empty) return;

        const updates = snapshot.docs.map(doc => doc.ref.update({ endDate }));
        await Promise.all(updates);

        const adminUsers = this.$store.state.users.users.filter(u => u.admin);
        if (!adminUsers.length) return;

        const candidate = this.getCandidate(this.candidateId);
        const candidateName = candidate ? `${candidate.firstName} ${candidate.lastName}` : 'Onbekende kandidaat';
        const twoMinutesFromNow = new Date(Date.now() + 2 * 60 * 1000);
        const timeString = moment(twoMinutesFromNow).utc().format('HH:mm');

        store.dispatch('notifications/createReminder', {
          ApiClient: Vue.prototype.$ApiClient,
          departments: this.$store.getters.getUserData.departments,
          subject: 'Let op ziek uit dienst mededeling',
          message: `Let op: ${candidateName} was ziek gemeld en heeft een einddatum gekregen op zijn plaatsing (${endDate}). De ziekmelding is automatisch afgesloten.`,
          day: null,
          time: timeString,
          type: 'one-off',
          userIds: adminUsers.map(u => u.id),
        });
      } catch (e) {
        console.error('Fout bij verwerken ziekmelding bij plaatsingseinde:', e);
      }
    },
    getPlacement(id) {
      return this.getCandidatePlacements(this.candidateId).find(p => p.id === id);
    },
    getCustomerName(id) {
      return this.getCustomer(id).name;
    },

    getCustomerLocation(id) {
      return this.getCustomer(id) ? this.getCustomer.location : null;
    },
    getCandidate(id) {
      return this.getCandidates.find(candidate => candidate.id === id);
    },
  },
  computed: {
    isAdmin() {
      return Can(RIGHTS.IS_ADMIN) || Can(RIGHTS.CANDIDATE_PLACEMENT_EDIT);
    },
    ...mapGetters("placements", ["getCandidatePlacements"]),
    ...mapGetters("customers", ["getCustomer"]),
    ...mapGetters("vacancies", ["getVacancyName"]),
    ...mapGetters("candidates", ["getCandidates"]),
  },
};
</script>
